<template>
    <kiosk-layout formContainer>
        <page-loading v-if="loading"></page-loading>
        <div v-else>
            <page-header class="vx-mb-6 lg:vx-mb-12">
                <template v-slot:subtitle>
                    <a href="/kiosk/users" class="!vx-no-underline !vx-text-sky-600 vx-text-base vx-font-normal">
                        <font-awesome-icon class="vx-mr-1" :icon="faArrowLeft"></font-awesome-icon>
                        Search
                    </a>
                </template>

                {{ user.name }}

                <template v-slot:actions>
                    <vx-button
                        color="primary"
                        @click="impersonate()"
                        :disabled="props.userId === currentUserId || user.isUsingSingleSignOn"
                    >
                        Impersonate <font-awesome-icon :icon="faMasksTheater"></font-awesome-icon>
                    </vx-button>
                </template>
            </page-header>

            <div class="vx-grid vx-grid-cols-12">
                <page-sidebar
                    :links="[
                        { href: `/kiosk/users/${props.userId}`, label: 'Details' },
                        { href: `/kiosk/users/${props.userId}/teams`, label: 'Teams' },
                    ]"
                ></page-sidebar>

                <slot></slot>
            </div>
        </div>

        <warning-modal
            v-model:visible="showModal"
            title="Not a team member"
            message="It is not possible to impersonate a user that is a member of no teams."
            confirmText="Ok"
            @confirm="showModal = false"
            :cancelBtn="false"
        ></warning-modal>
    </kiosk-layout>
</template>

<script setup>
import { faArrowLeft, faMasksTheater } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { onMounted, ref } from 'vue';
import PageLoading from '~/components/general/PageLoading.vue';
import PageHeader from '~/components/general/PageHeader.vue';
import PageSidebar from '~/components/general/PageSidebar.vue';
import { useUserDetails } from './useUserDetails';
import { VxButton } from '@voxie/frontend-components';
import KioskLayout from '~/components/kiosk/KioskLayout.vue';
import WarningModal from '~/components/modals/WarningModal.vue';

const props = defineProps({
    userId: {
        type: Number,
        required: true,
    },
});

const { mount, user, loading } = useUserDetails();
const showModal = ref(false);
const currentUserId = Spark.state.user.id;

onMounted(() => {
    mount(props.userId);
});

const impersonate = () => {
    if (user.value.current_team_id !== null) {
        window.location = '/spark/kiosk/users/impersonate/' + props.userId;
    } else {
        showModal.value = true;
    }
};
</script>
